import { render, staticRenderFns } from "./OutOfStockModal.vue?vue&type=template&id=5f63c63d&scoped=true"
import script from "./OutOfStockModal.vue?vue&type=script&lang=js"
export * from "./OutOfStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63c63d",
  null
  
)

export default component.exports